module.exports = __webpack_public_path__ + "media/images/ui__arrowLeftInactive-dff641e2d9e2b9019316cd9899b20837.png";